'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAudiotrack = function ImageAudiotrack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
  );
};
ImageAudiotrack = (0, _pure2.default)(ImageAudiotrack);
ImageAudiotrack.displayName = 'ImageAudiotrack';

exports.default = ImageAudiotrack;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/audiotrack.js
 ** module id = 1546
 ** module chunks = 0
 **/